module.exports = __webpack_public_path__ + "img/mini-016.c9a9007c.jpg";